<ng-container *transloco="let t">
  <a
    href="#main"
    class="sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:rounded-control focus:bg-surface focus:px-3 focus:py-2 focus:text-text-link"
    (click)="$event.preventDefault(); main.focus()"
    >{{ t('nav.skipToContent') }}</a
  >

  <div class="flex h-full flex-col">
    @if (size() !== 'phone') {
      <app-top-bar class="shrink-0" />
    }
    <!-- Outside <main>: tailwind.css stretches every direct child of main to the full height. -->
    @if (profileFailed()) {
      <div class="w-full shrink-0 px-4 pt-4 md:px-6 md:pt-8">
        <app-form-load-error class="mx-auto block max-w-7xl" [message]="t('nav.profileLoadFailed')" (retry)="retryProfile()" />
      </div>
    }
    @if (showStartReturn()) {
      <div class="w-full shrink-0 px-4 pt-4 md:px-6 md:pt-8">
        <app-getting-started-return class="mx-auto block max-w-7xl" />
      </div>
    }
    @if (closedNotice()) {
      <div class="w-full shrink-0 px-4 pt-4 md:px-6 md:pt-8">
        <div appCard="alert" class="mx-auto max-w-7xl" role="status">
          <p appCardBody>
            @if (closedReason() === 'planEnded') {
              {{ t('trialNotice.planEnded') }}
            } @else {
              {{ t('trialNotice.trialEnded', { date: trialEndedOn() }) }}
            }
            @if (size() === 'computer') {
              <a routerLink="/settings/plan" class="font-semibold underline">{{ t('trialNotice.choosePlan') }}</a>
            } @else {
              {{ t('trialNotice.onComputer') }}
            }
          </p>
        </div>
      </div>
    }
    <main
      #main
      id="main"
      tabindex="-1"
      class="app-scroller min-h-0 flex-1 overflow-y-auto page-padding bg-background focus-visible:outline-none"
      [class.has-tab-bar]="size() === 'tablet'"
    >
      @if (supported()) {
        <router-outlet></router-outlet>
      } @else {
        <app-size-message />
      }
    </main>
    @if (size() === 'computer') {
      <footer class="shrink-0 px-6 py-2 bg-surface border-t border-border-default text-caption text-text-secondary">
        <div class="mx-auto flex max-w-7xl items-center justify-between gap-3">
          @if (wineryLoading()) {
            <div role="status" aria-busy="true">
              <span class="sr-only">{{ t('nav.loading') }}</span>
              <span class="block h-3 w-32 rounded-control bg-skeleton animate-pulse" aria-hidden="true"></span>
            </div>
          } @else {
            <span class="font-semibold text-text-primary">{{ winery()?.name ?? t('nav.wineryFallback') }}</span>
          }
          <span>{{ t('nav.version', { version: version, environment: environmentName | environmentLevel | titlecase }) }}</span>
        </div>
      </footer>
    }
  </div>

  @if (size() === 'tablet') {
    <app-bottom-tab-bar />
  }
</ng-container>
